import { render, staticRenderFns } from "./GraduateCard.vue?vue&type=template&id=4f7b74fa&"
import script from "./GraduateCard.vue?vue&type=script&lang=js&"
export * from "./GraduateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports